import React, { useContext, useState } from 'react'

import { GatsbyImage } from 'gatsby-plugin-image'
import { useStaticQuery, graphql } from 'gatsby'
import StoreContext from 'src/context/StoreContext'
import PropTypes from 'prop-types'
import Analytics from 'src/utils/Analytics'
import {
  Section,
  Heading,
  Strike,
  Highlight,
  SubHeading,
  FamilyImage,
  CtaContainer,
  PriceContainer,
  ContentContainer,
  PromotionDetails,
} from './styles'

import AddToCartButton from '../../AddToCartButton'
import { LOCALIZATION } from '../../../utils/constants'
import { HiddenOnMobile, HiddenOnDesktop } from '../../../utils/styles/global-styles'

const BetterHelpOffer = ({ offerRedeemed, setHasBetterHelp }) => {
  const { betterHelpFamily, betterHelpProduct, loveveryPartner, loveveryProduct } =
    useStaticQuery(graphql`
      query BetterHelpOfferQuery {
        betterHelpFamily: file(relativePath: { eq: "better-help-family.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        loveveryPartner: file(relativePath: { eq: "lovevery.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        betterHelpProduct: shopifyProduct(handle: { eq: "betterhelp-one-month-online-therapy" }) {
          variants {
            storefrontId
          }
        }
        loveveryProduct: shopifyProduct(handle: { eq: "lovevery-gift" }) {
          variants {
            storefrontId
          }
        }
      }
    `)

  const {
    variants: [{ storefrontId: betterHelpProductID }],
  } = betterHelpProduct || { variants: [{ storefrontId: null }] }

  const {
    variants: [{ storefrontId: loveveryProductID }],
  } = loveveryProduct || { variants: [{ storefrontId: null }] }

  const [submitting, setSubmitting] = useState(false)

  const { addToCart } = useContext(StoreContext)

  const handleAddToCart = async (variantId, quantity) => {
    if (!submitting) {
      setSubmitting(true)
      Analytics.track(`Added Better Help Offer to Cart`)
      const items = [{ variantId, quantity }]
      const resp = await addToCart(items)
      if (resp && resp.error) {
        setSubmitting(false)
        alert(resp.error)
      } else {
        setSubmitting(false)
        setHasBetterHelp(true)
      }
    }
  }
  const DETAILS = {
    'en-au': `About 60% of Aussie parents are dissatisfied with the amount of time they spend on self-care. With Skylight x BetterHelp, you'll receive a free month of online therapy with your purchase of a Skylight Calendar in celebration of World Mental Health Day.`,
    'en-gb': `Over 80% of UK parents admit to experiencing at least one warning sign of parental burnout. With Skylight x BetterHelp, you'll receive a free month of online therapy with your purchase of a Skylight Calendar in celebration of World Mental Health Day.`,
    en: `Purchase a Skylight Calendar and receive a $50 Lovevery.com discount code to help bring more balance, play, and joy into your child's routine.`,
    offerRedeemed:
      // 'Be on the lookout for an email immediately after you place your order containing a link directing you where to redeem your free month of therapy, courtesy of BetterHelp.',
      'Be on the lookout for an email immediately after you purchase containing a unique code that you can apply at checkout at Lovevery.com.',
  }
  const PRICE = {
    'en-au': '$350',
    'en-gb': '£300',
  }
  const DEAL_DETAILS = {
    betterHelp: {
      offerTitle: 'Redeem your Month of',
      amount: 'FREE',
      offerTitle2: 'Therapy',
      cta: 'Redeem Your Offer',
      image: betterHelpFamily,
      alt: 'Better Help family sitting on couch illustration',
    },
    lovevery: {
      offerTitle: 'Redeem Your',
      amount: '$50',
      offerTitle2: 'Lovevery Gift',
      cta: 'Redeem Your Gift',
      image: loveveryPartner,
      alt: 'Toddler playing with Lovevery toys',
    },
  }
  const lovevery = true

  const deal = lovevery ? DEAL_DETAILS.lovevery : DEAL_DETAILS.betterHelp
  const { offerTitle, amount, offerTitle2, cta, image, alt } = deal
  return (
    <Section lovevery={lovevery}>
      {!offerRedeemed && (
        <FamilyImage>
          <HiddenOnMobile>
            <GatsbyImage image={image.childImageSharp.gatsbyImageData} alt={alt} />
          </HiddenOnMobile>
        </FamilyImage>
      )}
      <ContentContainer>
        {offerRedeemed ? (
          <Heading lovevery={lovevery}>
            <Highlight lovevery={lovevery}>Nice Work!</Highlight> Your Little One Will Love This
            Gift!
          </Heading>
        ) : (
          <Heading lovevery={lovevery}>
            {offerTitle} <Highlight lovevery={lovevery}>{amount}</Highlight>
            {` ${offerTitle2}`}
          </Heading>
        )}
        <SubHeading lovevery={lovevery}>
          {offerRedeemed ? DETAILS.offerRedeemed : DETAILS[LOCALIZATION]}
        </SubHeading>
        {!offerRedeemed && (
          <HiddenOnDesktop>
            <GatsbyImage image={image.childImageSharp.gatsbyImageData} alt={alt} />
          </HiddenOnDesktop>
        )}
        {!offerRedeemed && (
          <PriceContainer offerRedeemed={offerRedeemed} hideOnDesktop={lovevery}>
            <Heading normal right={!offerRedeemed}>
              <Strike>{PRICE[LOCALIZATION]}</Strike>{' '}
              <Highlight black lovevery={lovevery}>
                {amount}
              </Highlight>
            </Heading>
          </PriceContainer>
        )}
        <CtaContainer>
          {!offerRedeemed && (
            <AddToCartButton
              label={cta}
              backgroundColor={lovevery ? '#00B389' : '#96E093'}
              textcolor={lovevery ? '#FAF7F3' : '#1A4C3D'}
              handleClick={() =>
                handleAddToCart(lovevery ? loveveryProductID : betterHelpProductID, 1)
              }
              oos={false}
              adding={submitting}
            />
          )}
        </CtaContainer>
        {!offerRedeemed && (
          <PromotionDetails>
            <span>Promotion ends 11/11 or while supplies last.</span>
          </PromotionDetails>
        )}
      </ContentContainer>
    </Section>
  )
}

export default BetterHelpOffer

BetterHelpOffer.propTypes = {
  offerRedeemed: PropTypes.bool.isRequired,
  setHasBetterHelp: PropTypes.func.isRequired,
}
